import InputBase from '@mui/material/InputBase';

import { withStyles } from 'makeStyles';

export const TMXBaseInput = withStyles(InputBase, (theme) => ({
  input: {
    // borderRadius: 3,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    // border: 'solid 1px #dadce0',
    // padding: '8px 40px 8px 13px',
    // padding: `${theme.spacing(1)} 26px ${theme.spacing(1)} 12px`,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    flexGrow: 0,
    // fontFamily: Avenir-Roman;
    // fontSize: 15,
    // fontWeight: 'normal',
    // letterSpacing: 'normal',
    // textAlign: 'left',
    '&:focus': {
      borderRadius: 3,
      backgroundColor: theme.palette.background.paper,
    },
  } as const,
}));
